import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputItem from './input-item';

export const CheckPriceReqFreightLCLForm = ({
  subFeeList = [],
  unitList = [],
  name,
  requiredTitle = 'Vui lòng nhập thông tin',
  value,
  label = '',
  onChange,
  error = false,
  helperText = '',
  disabledField = false,
  disabledResponseCheck = false,
  widthContainerLeft = '45%',
  widthContainerBody = '65%',
  hasInitData = false,
}) => {
  const initialValue = {
    arrFeeGroup: [],
    requestPrice: 0,
    quantity: 0,
    unitCode: '',
  };
  const [values, setValues] = React.useState(hasInitData ? [] : [initialValue]);
  const initRef = React.useRef(true);

  const onAdd = () => {
    setValues((prev) => {
      let tmp = [...prev];
      tmp.push({
        arrFeeGroup: [],
        requestPrice: 0,
        quantity: 0,
        unitCode: '',
      });
      return tmp;
    });
  };
  const onDelete = (index) => {
    if (values && values.length === 1) {
      setValues([initialValue]);
    } else {
      setValues((prev) => {
        prev.splice(index, 1);
        return [...prev];
      });
    }
  };

  React.useEffect(() => {
    if (initRef.current && value?.length) {
      setValues(value);
      initRef.current = false;
    }
  }, [value]);
  React.useEffect(() => {
    onChange &&
      onChange({
        persist: () => {},
        target: {
          type: 'change',
          name,
          value: values,
        },
      });
  }, [values]);

  const renderItems = (item, index) => {
    return (
      <InputItem
        key={'price board-' + index}
        item={item}
        index={index}
        onAdd={onAdd}
        onDelete={onDelete}
        values={values}
        setValues={setValues}
        error={error}
        disabledField={disabledField}
        disabledResponseCheck={disabledResponseCheck}
        widthContainerLeft={widthContainerLeft}
        widthContainerBody={widthContainerBody}
        subFeeList={subFeeList}
        unitList={unitList}
      />
    );
  };
  return (
    <FormGroup margin="dense">
      <FormLabel>{label}</FormLabel>
      {values.map((item, index) => renderItems(item, index))}
      <FormHelperText error={error}>{helperText && requiredTitle}</FormHelperText>
    </FormGroup>
  );
};
